import { useMemo, useState } from 'react';
import PageHeader from 'src/components/page-header/page-header';
import FilterTags from 'src/components/tags/filter-tags';
import css from './partnership.module.scss';
import { useGetPartners, useGetPartnerTags } from './api/queries';
import { Partner, PartnerCategory } from './types';

export default function Partnership() {
  const [selectedTag, setSelectedTag] = useState<string | undefined>(undefined);

  const { data: partners = [] } = useGetPartners({ tagId: selectedTag });
  const { data: tags = [] } = useGetPartnerTags();

  const concatedTags = useMemo(() => [{ id: undefined, name: 'Усі' }].concat(tags), [tags]);

  return (
    <main className={css.partnershipContainer}>
      <PageHeader
        title='Партнери та надавачі послуг'
        description='Залучено близько 100 партнерів та надавачів послуг, до яких належать центральні органи виконавчої влади, органи місцевого самоврядування, громадські організації та комерційні компанії'
      />
      <div className={css.list}>
        <FilterTags
          title={''}
          tags={concatedTags.map((t) => t.id)}
          selectedTag={selectedTag}
          calcName={(tagId) => concatedTags.find((t) => t.id === tagId)?.name}
          onClick={setSelectedTag}
        />
        {partners.map((c: PartnerCategory) => (
          <div key={c.id} className={css.partnersGroup}>
            <div className={css.header}>
              <p>{c.name}</p>
            </div>
            <div className={css.logos}>
              {c.partners.map((p: Partner) => (
                <a href={p.url} key={p.id} target='_blank' rel='noopener noreferrer' title={p.name}>
                  <img src={p.imgUrl} alt={p.name} />
                </a>
              ))}
            </div>
          </div>
        ))}
      </div>
    </main>
  );
}
